import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormTitle from '../../../../library/form/components/FormTitle'
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent, UiGridColTwo } from "../../../../library/layout/Index";
import DocAdminInfo from '../../../cmn/DocAdminInfo';

const LocationHeaderViewer = (props) => {
    const { formObject } = props;

    return (
        <>

            <UiView>
                <UiViewHeading>
                    <UiTitle>
                        <span>
                            <FormTitle formObject={formObject} value='Location Detail' />
                        </span>
                    </UiTitle>

                    <UiAction>
                        <DocAdminInfo formObject={formObject} rowKey="" headerKey="adminInfo"/>
                        <FormButton formObject={formObject} ksc="h" rowKey=""
                            starIcon={"edit"}
                            action={{ actionId: "edit",  actionParam: {}, containerKey: "popup" }}
                            className="uiActionButton" text={<SarasTrans value="Edit" />}></FormButton>
                    </UiAction>

                </UiViewHeading>
                <UiViewContent>
                    <UiGridColTwo>
                        <div className="uiCol">
                            <ul>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "locId" }} value="Location I" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "locId" }} />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "locName" }} value="Location Name" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "locName" }} />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "LocCode" }} value="Location Code" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "LocCode" }} />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "nickName" }} value="Nick Name" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "nickName" }} />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "address" }} value="Address" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "address" }} />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "salesOrderBG" }} value="Sales Order BG" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "salesOrderBG" }} />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "salesOrderCC" }} value="Sales Order CC" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "salesOrderCC" }} />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "salesInvoiceBG" }} value="Sales Invoice BG" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "salesInvoiceBG" }} />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "salesInvoiceCC" }} value="Sales Invoice CC" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "salesInvoiceCC" }} />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "length" }} value="Length" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "length" }} />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "breadth" }} value="Breadth" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "breadth" }} />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "height" }} value="Height" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "height" }} />
                                </li>
                            </ul>
                        </div>
                        <div className="uiCol">
                            <ul>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "parentLoc" }} value="Parent Location" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "parentLoc" }} />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "pLocType" }} value="Location Type" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "pLocType" }} />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "locGroup" }} value="Location Group" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "locGroup" }} />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "locCountry" }} value="Location Country" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "locCountry" }} />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "styleAttr" }} value="Style Attribute" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "styleAttr" }} />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "sortNo" }} value="Sort No" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "sortNo" }} />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "creditNoteBG" }} value="Credit Note BG" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "creditNoteBG" }} />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "creditNoteCC" }} value="Credit Note CC" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "creditNoteCC" }} />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isActive" }} value="Is Active ?" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "isActive" }} />

                                    <span className="uiLblInLine">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isExternal" }} value="Is External ?" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "isExternal" }} />

                                    <span className="uiLblInLine">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isStorage" }} value="Is Storage ?" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "isStorage" }} />
                                    
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "showOnApp" }} value="Show On App ?" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "showOnApp" }} />

                                    <span className="uiLblInLine">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "showOnReport" }} value="Show On Report ?" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "showOnReport" }} />
                                </li>
                            </ul>
                        </div>
                    </UiGridColTwo>
                </UiViewContent>
            </UiView>
        </>
    )
}

export default withView(LocationHeaderViewer, "locationHeader", "");